const handledByFilter = {
  all: 'all',
  mine: 'mine',
  no_owner: 'no_owner',
  select: 'select',
};

export { handledByFilter };
